import { renderAccountRoutes } from './customer-route-protected/renderAccountRoutes'
import { renderOrderRoutes } from './customer-route-protected/renderOrderRoutes'
import { renderSupportRoutes } from './customer-route-protected/renderSupportRoutes'
import type { CustomerProtectedRendererInput } from './customer-route-protected/types'

export const renderCustomerProtectedContent = ({
  onNavigate,
  viewModel,
}: CustomerProtectedRendererInput) => {
  const account = viewModel.account
  const profile = viewModel.profile

  if (!account || !profile) {
    return null
  }

  const orderView = renderOrderRoutes({ onNavigate, viewModel })
  if (orderView) {
    return orderView
  }

  const supportView = renderSupportRoutes({ onNavigate, viewModel })
  if (supportView) {
    return supportView
  }

  return renderAccountRoutes({ onNavigate, viewModel })
}
